import { render, staticRenderFns } from "./MarketOrderStatusBadge.vue?vue&type=template&id=53597b92&"
import script from "./MarketOrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./MarketOrderStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports